<template>
  <div>
    <topPage :title="title" :bgImg="bgImg" />
    <ImgAndTextRight
      id="next"
      bgcolor="#817CF1"
      img="computer4.png"
      title="le syndic c’est quoi ?"
      text="Généralement, on utilise un texte en faux latin (le texte ne veut rien dire, il a été modifié), le Lorem ipsum ou Lipsum, qui permet donc de faire office de texte d’attente. L’avantage de le mettre en latin est que l’opérateur sait au premier coup d’oeil que la page contenant ces lignes n’est pas valide, et surtout l’attention du client n’est pas dérangée par le contenu, il demeure concentré seulement sur l’aspect graphique."
      btn="en savoir +"
    ></ImgAndTextRight>
    <itemList
      color="#817CF1"
      title="NOTRE OFFRES"
      text="Généralement, on utilise un texte en faux latin (le texte ne veut rien dire, il a été modifié), le Lorem ipsum ou Lipsum, qui permet donc de faire office de texte d’attente. L’avantage de le mettre en latin est que"
      :list="list"
    ></itemList>
    <crew
      color="#817CF1"
      title="NOTRE OFFRES"
      text="Généralement, on utilise un texte en faux latin (le texte ne veut rien dire, il a été modifié), le Lorem ipsum ou Lipsum, qui permet donc de faire office de texte d’attente. L’avantage de le mettre en latin est que"
      :list="crew"
    ></crew>
  </div>
</template>

<script>
import topPage from "../components/topPage";
import ImgAndTextRight from "../components/imageAndTextRight";
import itemList from "../components/itemList";
import crew from "../components/crew";
export default {
  name: "Syndic",
  components: { topPage, ImgAndTextRight, itemList, crew },
  data: () => ({
    title: "Syndic",
    bgImg: "syndic_illu.png",
    list: [
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      }
    ],
    crew: [
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      },
      {
        img: "test.png",
        title: "test",
        text: "balbalba balba blab lbalba bal"
      }
    ]
  })
};
</script>
